import 'babel-polyfill'
import 'bootstrap'
import noUiSlider from 'nouislider';

import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import Dropzone from 'dropzone';

// Styling
import '../scss/style.scss'

// Fontawesome
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faStar, faStarHalfStroke } from '@fortawesome/free-solid-svg-icons'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons'
library.add(faFacebookF, faTwitter, faInstagram, faLinkedin, faStar, farStar, faStarHalfStroke)
dom.watch()

// General
jQuery(document).ready(function ($) {
    if ($('.login.wp-core-ui').length) {
        $('#user_login').attr('placeholder', 'Gebruikersnaam of e-mailadres');
        $('#user_pass').attr('placeholder', 'Wachtwoord')
    }

    if ($('.configurator__dropzone').length) {
        let dropzone = new Dropzone('.configurator__dropzone', {
            url: '/wp-admin/admin-ajax.php?action=configurator_upload_image',
            maxFilesize: 10 * 1024 * 1024,
            acceptedFiles: 'image/*',
            disablePreviews: true,
        });
        dropzone.on('sending', function (file, xhr, formData) {
            formData.append('step', $('.configurator__dropzone').data('step'));
        });
        dropzone.on('addedfile', function (file) {
            $('.configurator__dropzone-files').append(`<div class="configurator__dropzone-file" data-uuid="${file.upload.uuid}"><div>${file.name}</div><div class="configurator__dropzone-progress-bar-wrapper"><div class="configurator__dropzone-progress-bar" style="width: 0%;"></div></div></div>`);
        });
        dropzone.on('uploadprogress', function (file, progress, bytesSent) {
            $(`.configurator__dropzone-file[data-uuid="${file.upload.uuid}"] .configurator__dropzone-progress-bar`).css('width', `${progress * 0.9}%`);
        });
        dropzone.on('success', function (file, response) {
            let filesize = '';
            if (file.size < 1024) {
                filesize = `${file.size} b`;
            } else if (file.size < 1024 * 1024) {
                filesize = `${Math.round(file.size / 1024)} kb`;
            } else {
                filesize = `${Math.round(file.size / 1024 / 1024)} mb`;
            }
            let id = response.data.id;
            $(`.configurator__dropzone-file[data-uuid="${file.upload.uuid}"]`).html(`<div>${file.name}</div><div>${filesize}<div class="configurator__dropzone-file-remove" data-id="${id}"></div></div>`);
        });
        dropzone.on('error', function (file, response) {
            $(`.configurator__dropzone-file[data-uuid="${file.upload.uuid}"]`).html(`<div>${file.name}</div><div class="text-danger">Error</div>`);
        });

        // On remove click, send request 
        $('.configurator__dropzone-files').on('click', '.configurator__dropzone-file-remove', function () {
            if ($(this).hasClass('disabled')) return;
            $(this).addClass('disabled');
            let id = $(this).data('id');
            let file = $(this).closest('.configurator__dropzone-file');
            // send request to configurator_remove_image with id in form data
            $.ajax({
                url: '/wp-admin/admin-ajax.php?action=configurator_remove_image',
                method: 'POST',
                data: {
                    id: id,
                    step: $('.configurator__dropzone').data('step'),
                },
                success: function (response) {
                    file.remove();
                }
            });
        });
    }

    $('.shop__filter-header-mobile').on('click', function () {
        $(this).toggleClass('active');
        $('.shop__filter-form').toggleClass('active');
    });

    $('.product__specs-buttons .btn').on('click', function () {
        $('.product__specs-buttons .btn.selected, .product__specs-list.selected').removeClass('selected');
        $(this).addClass('selected');
        $(`.product__specs-list[data-index="${$(this).data('index')}"]`).addClass('selected');
    })

    $('.configurator__buttons .btn').on('click', function (e) {
        if ($('.configurator__dropzone-progress-bar').length) {
            e.preventDefault();
            alert('Wacht alsjeblieft tot de geselecteerde afbeeldingen zijn geüpload');
        }
    });

    function showProductQuotation() {
        //.navbar-collapse li:not(:last-child),
        $('main.product, footer.footer, .navbar-type-toggler,  .header-usps-wrapper').addClass('d-none').removeClass('d-lg-block');
        $('main.product-quotation').removeClass('d-none');
        $('header.header').removeClass('top');

        let postValues = $('.product-quotation__form').data('post');

        let elements = [];
        $('.tc-element-inner-wrap').each(function () {
            let field = $(this).find('.tm-epo-field');
            let type = field.prop('tagName') == 'SELECT' ? 'select' : field.attr('type');
            let name = $(this).find('.tc-epo-label').text().trim();
            let options = null;
            let value = null;
            if (type == 'select') {
                options = [];
                field.find('option').each(function () {
                    options.push($(this).text().trim());
                });

                if (postValues['product_' + name]) {
                    value = postValues['product_' + name];
                } else {
                    value = field.find('option:selected').text().trim();
                }
            } else {
                if (postValues['product_' + name]) {
                    value = postValues['product_' + name];
                } else {
                    value = field.val();
                }
            }

            elements.push({
                name: name,
                type: type,
                options: options,
                value: value
            })
        });

        let itemContainer = $('.product-quotation__options');
        let html = '';
        elements.forEach(function (element) {
            html += '<div class="col-lg-6">'
            html += `<label for="${element.name}" class="form-label">${element.name}</label>`;
            if (element.type == 'select') {
                html += `<select name="product_${element.name}" id="${element.name}" class="form-select">`;
                element.options.forEach(function (option) {
                    html += `<option value="${option}" ${option == element.value ? 'selected' : ''}>${option}</option>`;
                });
                html += '</select>';
            } else {
                html += `<input type="${element.type}" name="${element.name}" id="${element.name}" class="form-control" value="${element.value}">`;
            }
            html += '</div>';
        });
        itemContainer.prepend(html);

        $('.product-quotation__options input[name="quantity"]').val($('input.qty').val());
    }

    if ($('.product-quotation .is-invalid').length || $('.product-quotation__finished').length) {
        showProductQuotation();
    }

    let cart = $('.navbar-cart');
    if (cart.length) {
        // Move navbar cart before last navbar item
        $('.navbar-nav > li:last-child').before(cart);
        cart.removeClass('d-none');
    }

    $('.product__quotation').on('click', function (e) {
        e.preventDefault();
        showProductQuotation();
    })

    if ($('.configurator__length-slider').length) {
        let input = $('.configurator__length-input');
        let slider = noUiSlider.create($('.configurator__length-slider')[0], {
            range: {
                min: [parseInt(input.data('min'))],
                max: [parseInt(input.data('max'))]
            },
            start: parseInt(input.val()),
            step: 1,
            connect: 'lower',
        });
        slider.on('update', function (values, handle) {
            input.val(values[handle]);
            $('.configurator__length-slider-text').text(parseInt(values[handle]) + ' meter');
        });
    }

    $('.product__images-others-item').on('click', function () {
        $('.product__images-main').html($(this).data('img-full'));
    });

    if ($(".product-slide").length) {

        const swiper = new Swiper('.product-swiper', {
            modules: [Navigation, Pagination, Scrollbar],
            slidesPerView: 1.2,
            breakpoints: {
                992: {
                    slidesPerView: 4.5,
                }
            },
            spaceBetween: 20,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: '.product-pagination',
                type: 'bullets',
                dynamicBullets: true,
                dynamicMainBullets: 2,
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
    if ($(".product-img-slide").length) {

        const swiper = new Swiper('.product-img-swiper', {
            modules: [Navigation, Pagination, Scrollbar],
            slidesPerView: 3.2,
            breakpoints: {
                992: {
                    slidesPerView: 3.2,
                }
            },
            spaceBetween: 20,
            pagination: {
                el: '.product-img-pagination',
                type: 'bullets',
                dynamicBullets: true,
                dynamicMainBullets: 2,
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    if ($('.product__description-text').length) {
        if ($('.product__description-text').innerHeight() < 300) {
            $('.product__description-read-more').addClass('d-none');
        } else {
            let height = $('.product__description-text').height();
            $('.product__description-text').css('height', '300px');

            $('.product__description-read-more').on('click', function () {
                $('.product__description-text').animate({
                    height: height,

                }, 500, function () {
                    $('.product__description-text').css('height', 'auto');
                });
                $(this).addClass('d-none');
            });
        }
    }

    if ($(".recommend-slide").length) {
        const swiper = new Swiper('.recommend-swiper', {
            modules: [Navigation, Pagination, Scrollbar],
            slidesPerView: 1.2,
            breakpoints: {
                992: {
                    slidesPerView: 4.5,
                }
            },
            spaceBetween: 20,
            centeredSlides: true,
            loop: true,
            loopedSlides: 3,
            pagination: {
                el: '.recommend-pagination',
                type: 'bullets',
                dynamicBullets: true,
                dynamicMainBullets: 2,
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
    let lastCollapsible;
    if ($('.collapsibles').length) {
        function toggleSlide(container) {
            let content = container.querySelector(".collapsibles__item-content");
            if (!container.classList.contains('active')) {
                container.classList.add('active');

                content.style.height = 'auto';

                var height = content.clientHeight + 'px';

                content.style.height = '0px';

                setTimeout(function () {
                    content.style.height = height;
                }, 0);
            } else {
                content.style.height = '0px';

                // content.addEventListener('transitionend', function () {
                container.classList.remove('active');
                // }, {
                //   once: true
                // });
            }
        };
        $('.collapsibles__item-header').click(function () {
            // $('.collapsibles__item').removeClass('active');
            if (typeof lastCollapsible !== typeof undefined && !lastCollapsible.isEqualNode(this)) {
                let container = lastCollapsible.parentElement;
                let content = container.querySelector(".collapsibles__item-content");
                content.style.height = '0px';

                // content.addEventListener('transitionend', function () {
                container.classList.remove('active');
            }
            // $(this).parent().toggleClass('active');
            toggleSlide(this.parentElement)

            lastCollapsible = this;

        });
    }
    if ($('.tabbed').length) {
        function toggleSlide(container, content) {
            if (!container.classList.contains('active')) {
                container.classList.add('active');

                content.style.height = 'auto';

                var height = content.clientHeight + 'px';

                content.style.height = '0px';

                setTimeout(function () {
                    content.style.height = height;
                }, 0);
            } else {
                content.style.height = '0px';

                // content.addEventListener('transitionend', function () {
                container.classList.remove('active');
                // }, {
                //   once: true
                // });
            }
        };
        $('.tabbed__tab').click(function () {
            $('.tabbed__tab').removeClass('active');
            $(this).addClass('active');
            $('.tabbed__content').removeClass('active').slideUp();
            $('.tabbed__content[data-id="' + $(this).data('id') + '"]').addClass('active').slideDown();

        });
        $('#tab-select').change(function () {
            let index = this.options[this.selectedIndex].dataset.id
            $('.tabbed__content').removeClass('active').slideUp();
            $('.tabbed__content[data-id="' + index + '"]').addClass('active').slideDown();
        });
    }
    function ifMobile() {
        return window.innerWidth < 992;
    }
    document.querySelectorAll("header .dropdown").forEach(x => {
        x.addEventListener("mouseenter", (e) => {
            if (!ifMobile())
                document.body.classList.add("active")
        })
        x.addEventListener("mouseleave", (e) => {
            if (!ifMobile())
                document.body.classList.remove("active")
        })
        x.addEventListener("click",e=>{
            if (!ifMobile())
                window.location.href=x.querySelector("a").href;
        })
    })
    if (!document.body.classList.contains("home") && document.querySelector(".header")) {
        window.addEventListener("scroll", e => {
            if (window.scrollY === 0 && !$('.product-quotation:not(.d-none)').length) {
                document.querySelector(".header").classList.add("top")
            } else {
                document.querySelector(".header").classList.remove("top")
            }
        })
    }

    // document.querySelectorAll("header .dropdown-toggle").forEach(x=>{
    //     x.addEventListener("click",e=>{
    //         if(ifMobile()){
    //             if(x.classList.contains("show")){
    //                 document.body.classList.add("active")
    //             }else{
    //                 document.body.classList.remove("active")
    //             }

    //         }   
    //     })
    // })
    document.querySelectorAll(".navbar-toggler").forEach(x => [
        x.addEventListener("click", e => {
            document.body.classList.toggle("active")
        })
    ])
    let btnForm = document.querySelector("#btn-form")
    if (btnForm) {
        btnForm.addEventListener("click", e => {
            btnForm.closest("form").querySelector("input[type='submit']").click()
        })
    }
    document.querySelectorAll(".shop__filter-form .form-select").forEach(x => {
        if (x.selectedIndex == 0) {
            x.classList.add("inactive")
        }
        x.addEventListener("change", e => {
            if (x.selectedIndex == 0) {
                x.classList.add("inactive")
            } else {
                x.classList.remove("inactive")
            }
        })
    })
    let shopFilter= document.querySelector(".shop__filter-form");
    if(shopFilter){
        let loading= document.querySelector(".shop-loading");
        shopFilter.onsubmit= function(e){
            if(e){
                e.preventDefault();
            }
            let row= document.querySelector(".shop-items-row")
            let formdata =  new FormData(shopFilter);
            let searchString= new URLSearchParams(formdata);
            loading.classList.remove("d-none");
            fetch("/wp-admin/admin-ajax.php?action=get_products&"+ searchString.toString()).then(res=>res.json()).then(res=>{
                row.innerHTML=res.content;
                loading.classList.add("d-none");
                if(res.more_pages && loadMorebtn){
                    loadMorebtn.classList.add("d-none")
                }else{
                    loadMorebtn.classList.remove("d-none")
                }
            })
        };
        shopFilter.submit= shopFilter.onsubmit;
        let loadMorebtn= document.querySelector(".shop__load-more");
        if(loadMorebtn){
            loadMorebtn.addEventListener("click",e=>{
                let limit =shopFilter.querySelector("[name='limit']");
                limit.value= Number(limit.value)+ 9;
                shopFilter.submit();
            })
        }
        shopFilter.querySelectorAll("select").forEach(x=>{
            x.addEventListener("change",e=>{
                shopFilter.querySelector("[name='limit']").value=9;
            })
        })
    }
    let filterForm = document.querySelector(".blog-filters form");
    if (filterForm) {
        filterForm.addEventListener("change", e => {
            filterForm.submit()
        })
    }

    var mouseX = 0,
        mouseY = 0;
    var xp = 0,
        yp = 0;
    $(document).mousemove(function (e) {
        mouseX = e.pageX;
        mouseY = e.pageY - document.documentElement.scrollTop
    });
    let mouseInterval = setInterval(function () {
        if (mouseX == 0 && mouseY == 0) {
            xp += ((mouseX - xp) / 6) - 100;
            yp += ((mouseY - yp) / 6)
        } else {
            xp += ((mouseX - xp) / 6);
            yp += ((mouseY - yp) / 6)
        }
        $('#cursor').css({
            left: xp + 'px',
            top: yp + 'px',
        })
    }, 13)
    // Change mouse cursor on mousemove
    $('body').mousemove(function (e) {
        if ($('.change-cursor:hover').length != 0) {
            var classList = e.target.className.split(/\s+/);
            for (var i = 0; i < classList.length; i++) {
                if (classList[i].startsWith('cursor-')) {
                    var color = classList[i].split('-')[1];
                    $('body').removeClass(function (index, section) {
                        return (section.match(/(^|\s)cursor-\S+/g) || []).join(' ');
                    });
                    $('body').addClass('cursor-image-' + color);
                }
            }
        } else {
            $('body').removeClass(function (index, section) {
                return (section.match(/(^|\s)cursor-\S+/g) || []).join(' ');
            });
        }

        $('.swiper-slide').mouseenter(function () {
            $('#cursor').addClass('show-slider-cursor');
        });
        $('.swiper-slide').mouseleave(function () {
            $('#cursor').removeClass('show-slider-cursor');
        });
    });
});

jQuery(document.body).on('wc_address_i18n_ready', function () {
    setTimeout(function () {
        jQuery('#billing_postcode_field, #shipping_postcode_field').removeClass('form-row-wide').addClass('form-row-first');
        jQuery('#billing_city_field, #shipping_city_field').removeClass('form-row-wide').addClass('form-row-last');
    }, 1)
});


